import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { theme } from 'config/theme'
import Container from 'components/atoms/Container'
import { Flex } from 'components/atoms/Layout'
import { H2 } from 'components/atoms/Typography'

const Background = styled.div`
  background-image: linear-gradient(#caece9, #ffffff);
  padding-top: ${theme.space.xxl};
  padding-bottom: ${theme.space.xxl};
`

const Hero = ({ children }) => (
  <Background>
    <Container>
      <Flex justifyContent="center">
        <H2>{children}</H2>
      </Flex>
    </Container>
  </Background>
)

Hero.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Hero
